var map = {
	"./amazon.png": "9f50",
	"./card-1.png": "63f4",
	"./card-2.png": "7131",
	"./card03.png": "da53",
	"./gfuel.png": "f0fb",
	"./keyboard.png": "cbdb",
	"./logitech.png": "2588",
	"./mouse.png": "b8cf",
	"./nike.png": "dcd1",
	"./pc.png": "eaa5",
	"./vbuks.png": "98a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a48";